import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import userMobx from '../../../mobx/user'
import { ClientI } from '../../../types-project/Client'
import { getMessageCredits } from '../../services/campaignInvite'
import campaignInviteStore from '../../../mobx/campaignInvite'

interface Props {
  className?: string
}

// Badge "X crédits message" : solde de credits d'invitation de la company.
// Se rafraichit a chaque envoi/achat via campaignInviteStore.balanceVersion.
// Cache tant que le solde n'est pas connu (evite un flash a 0).
const MessageCreditsBadge: React.FC<Props> = ({ className }) => {
  const userInfos = userMobx.getUserInfos() as ClientI | null
  const companyId =
    userMobx.me.data?._company?._id ?? userInfos?._company?._id ?? ''
  const [balance, setBalance] = useState<number | null>(null)
  const version = campaignInviteStore.balanceVersion

  useEffect(() => {
    let alive = true
    if (!companyId) return
    getMessageCredits(companyId)
      .then((r) => {
        if (alive) setBalance(r.balance)
      })
      .catch(() => {})
    return () => {
      alive = false
    }
  }, [companyId, version])

  if (balance === null) return null

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border border-[#e6e8f2] bg-white px-3 py-1.5 text-sm font-semibold text-[#3A4161] ${className ?? ''}`}
      title="Crédits d'invitation de créateurs"
    >
      <i className="fa-solid fa-paper-plane text-[#7885ed]" />
      {balance} crédit{balance > 1 ? 's' : ''} message
    </span>
  )
}

export default observer(MessageCreditsBadge)
